<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path [attr.d]="ICONS_LIST.icons1[p]"/>
</svg>
